import React, { useState, useEffect } from 'react';

const productsData = [
  {
    id: 1,
    name: '法式经典草莓蛋糕',
    category: 'classic',
    description: '新鲜草莓与香草奶油完美结合，入口即化',
    price: 298,
    originalPrice: 358,
    badge: '热销',
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=600&q=80',
    tag: '经典'
  },
  {
    id: 2,
    name: '皇家比利时巧克力',
    category: 'chocolate',
    description: '72%纯度黑巧克力，浓郁丝滑',
    price: 358,
    originalPrice: 428,
    badge: '新品',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600&q=80',
    tag: '巧克力'
  },
  {
    id: 3,
    name: '清新水果塔',
    category: 'fruit',
    description: '季节水果与卡仕达酱的清新搭配',
    price: 228,
    originalPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=600&q=80',
    tag: '水果'
  },
  {
    id: 4,
    name: '北海道芝士蛋糕',
    category: 'cheese',
    description: '日式轻芝士，绵密细腻入口即化',
    price: 268,
    originalPrice: 318,
    badge: '招牌',
    image: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=600&q=80',
    tag: '芝士'
  },
  {
    id: 5,
    name: '提拉米苏',
    category: 'classic',
    description: '意大利经典，咖啡与马斯卡彭的邂逅',
    price: 288,
    originalPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600&q=80',
    tag: '经典'
  },
  {
    id: 6,
    name: '榛子巧克力蛋糕',
    category: 'chocolate',
    description: '香脆榛子与丝滑巧克力的双重享受',
    price: 328,
    originalPrice: 398,
    badge: '限定',
    image: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=600&q=80',
    tag: '巧克力'
  },
  {
    id: 7,
    name: '芒果千层蛋糕',
    category: 'fruit',
    description: '新鲜芒果与层层班戟的完美结合',
    price: 298,
    originalPrice: null,
    badge: '新品',
    image: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=600&q=80',
    tag: '水果'
  },
  {
    id: 8,
    name: '双重芝士蛋糕',
    category: 'cheese',
    description: '轻芝士+重芝士的双重风味',
    price: 298,
    originalPrice: 358,
    badge: null,
    image: 'https://images.unsplash.com/photo-1524351199678-941a58a3df50?w=600&q=80',
    tag: '芝士'
  }
];

function SearchModal({ isOpen, onClose }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (query.trim().toLowerCase().length > 0) {
      const searchResults = productsData.filter(p =>
        p.name.toLowerCase().includes(query.toLowerCase()) ||
        p.description.toLowerCase().includes(query.toLowerCase()) ||
        p.tag.toLowerCase().includes(query.toLowerCase())
      );
      setResults(searchResults);
    } else {
      setResults([]);
    }
  }, [query]);

  const handleClose = () => {
    setQuery('');
    setResults([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={`search-modal ${isOpen ? 'active' : ''}`}>
      <button className="search-close" onClick={handleClose}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      <div className="search-content">
        <div className="search-input-wrapper">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          <input 
            type="text" 
            placeholder="搜索蛋糕、甜品..." 
            id="searchInput"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
        <div className="search-results">
          {results.map(product => (
            <div className="search-result-item" key={product.id}>
              <div className="search-result-image">
                <img 
                  src={product.image} 
                  alt={product.name}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '🍰';
                  }}
                />
              </div>
              <div className="search-result-info">
                <h4>{product.name}</h4>
                <p>¥{product.price} · {product.tag}</p>
              </div>
            </div>
          ))}
          {query && results.length === 0 && (
            <p style={{ textAlign: 'center', color: 'var(--color-text-muted)', padding: '40px 0' }}>
              未找到"{query}"相关产品
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchModal;
